export const ProjectOne = {
id:'1',
name:'SteamAstro',
techused:'BOOTSRAP, REACT, NODE, STEAMAPI',
description:'This web application can help steam users to know how much is the cost to get his wanted level.',
href:'https://github.com/Mistydz/SteamAstro',
web:'https://astro-s.herokuapp.com/'
}
export const ProjectTwo = {
id:'2',
name:'CryptoJetz',
techused:'NODE{Cheerio-Passport-MongoDB}',
description:'This is a CRUD app with a scraper that gets exchange rates and crypto prices & custom data inputs by admin.',
href:'https://github.com/Mistydz/Jetz',
web:'https://jet-z.herokuapp.com/'
}
export const ProjectThree = {
id:'3',
name:'Shirty',
techused:'Front-End, UI/UX Design, BrandMarketing',
description:'This is a front-end project with full brand structure (logo - scoial media - ads - products).',
href:'https://github.com/Mistydz/Shirtzy',
web:'https://shirtz-y.herokuapp.com/'
}
